import { NavigationService } from "../services/NavigationServices/NavigationService";
import { useStore } from "../stores/StoreContext";

export function useNavigationService(): NavigationService {
  const storeContext = useStore();
  return new NavigationService(storeContext);
}
